import loadable from '@loadable/component';

export const ReportsDetailGraphicConfigurationFilterContentCategory = loadable(
  () => import('./ReportsDetailGraphicConfigurationFilterContentCategory'),
);
